import { render } from "./SectionBorder.vue?vue&type=template&id=315f6eb6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/SectionBorder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "315f6eb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('315f6eb6', __exports__)) {
    api.reload('315f6eb6', __exports__)
  }
  
  module.hot.accept("./SectionBorder.vue?vue&type=template&id=315f6eb6", () => {
    api.rerender('315f6eb6', render)
  })

}


export default __exports__